import { Typography } from "@mui/material";
import { useCountdownMinutes } from "../../hooks/useCountdownMinutes";

type Props = {
  id: string;
  seconds: number | undefined;
  itemsKey: string;
};

export const ApproximateTimeText = ({ id, seconds, itemsKey }: Props) => {
  const minutes = useCountdownMinutes(id, seconds, itemsKey);

  if (minutes <= 0) return null;

  return (
    <Typography variant="body1" color="#1F293299" whiteSpace="nowrap">
      ~{minutes} min
    </Typography>
  );
};
